// extracted by mini-css-extract-plugin
export var section = "N_j";
export var sectionHeader = "N_cv";
export var sectionsWrapper = "N_ct";